<template>
  <div class="pt-5">
    <router-link :to="{ name: 'storeProfileInfo' }" class="dashboard-nav-link px-4">
      <div class="d-flex align-center">
        <img v-svg-inline class="icon mr-2" src="@/assets/icons/store-profile.svg" alt=""/>
        <span>Store Profile</span>
      </div>
    </router-link>
    <router-link :to="{ name: 'storePurchasable' }" class="dashboard-nav-link px-4">
      <div class="d-flex align-center">
        <img v-svg-inline class="icon mr-2" src="@/assets/icons/board.svg" alt=""/>
        <span>NFT for Sale</span>
      </div>
    </router-link>
    <router-link :to="{ name: 'storeRedeemable' }" class="dashboard-nav-link px-4">
      <div class="d-flex align-center">
        <img v-svg-inline class="icon mr-2" src="@/assets/icons/store-nft-redeem.svg" alt=""/>
        <span>NFT for Redemption</span>
      </div>
    </router-link>
    <router-link :to="{ name: 'receivingRecord' }" class="dashboard-nav-link px-4">
      <div class="d-flex align-center">
        <img v-svg-inline class="icon mr-2" src="@/assets/icons/store-receiving-record.svg" alt=""/>
        <span>Receiving Records</span>
      </div>
    </router-link>
    <router-link :to="{ name: 'proposal' }" class="dashboard-nav-link px-4">
      <div class="d-flex align-center">
        <img v-svg-inline class="icon mr-2" src="@/assets/icons/store-proposal.svg" alt=""/>
        <span>Proposal</span>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "StorePanelSidebar"
}

</script>

<style lang="scss">

.dashboard-nav-link {
  color: rgb(125, 135, 156) !important;
  text-decoration: none;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-left: 4px solid #fff;
  margin-bottom: 20px;

  svg {
    width: 20px;
  }

  &.router-link-exact-active {
    color: #283593 !important;
    border-left: 4px solid #283593;
  }

  &:hover {
    color: #283593 !important;
    border-left: 4px solid #283593;
  }
}
</style>